module.exports = __webpack_public_path__ + "./favicon.ico";


//////////////////
// WEBPACK FOOTER
// ./~/file-loader?name=./favicon.ico!./src/img/favicon.ico
// module id = 2507
// module chunks = 0